import React from 'react'
import styled from 'styled-components'
import { Button } from 'antd' // Oletetaan, että käytät Ant Designia
import { MinusOutlined, PlusOutlined } from '@ant-design/icons'

// Styled Components
const ButtonContainer = styled.div`
  position: absolute;
  top: 0;
  left: -12px;
`

const StyledButton = styled(Button)`
  transform: scale(0.7);
`

interface ToggleButtonProps {
  node: any
  nodeId: string
  onToggle: (id: string) => void
}

const ToggleButton = ({ node, nodeId, onToggle }: ToggleButtonProps) => {
  return (
    <ButtonContainer>
      <StyledButton
        icon={node.expanded ? <MinusOutlined /> : <PlusOutlined />}
        onClick={() => onToggle(nodeId)}
        data-cy={`toggle-button-${nodeId}`}
      />
    </ButtonContainer>
  )
}

export default ToggleButton
